import axios from 'axios';

import EspecialidadesTabla from '../types/EspecialidadesTabla';


async function GuardarEspecialidad(prmEspecialidad: EspecialidadesTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_especialidad"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "especialidad": {
                "id": prmEspecialidad.id,
                "especialidad": prmEspecialidad.especialidad,
                "habilitado": prmEspecialidad.habilitado,
                "fch_modi": prmEspecialidad.fecha_modificacion,
                "dado_de_baja": prmEspecialidad.dado_de_baja,
                "fch_baja": prmEspecialidad.fecha_baja
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarEspecialidad;